import React, { useMemo } from 'react'
import { Card } from 'antd'
import { HourglassOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

import { currency, qtyToCurrency } from 'utils/formatting'
import { transType } from 'utils/static'
import { ItemRow, ItemsRow } from 'components/apps/Reports/PosShift/Detail/ItemsRow'
import SectionHeader from 'components/apps/Reports/PosShift/Detail/SectionHeader'
import styles from './detail.module.scss'

const DetailGroup = ({ title, items }) => {
  if (!items.length) {
    return null
  }

  return (
    <div>
      <div className={styles.subgroupTitle}>
        {title}
        <span className={styles.categoryCount}>({items.length})</span>
      </div>
      <div className={styles.paymentDetailList}>
        {items.map((item, index) => (
          <div key={`${item.trans_type_id}-${item.id}`} className={styles.paymentDetailRow}>
            <span className={styles.paymentDetailInvoiceRef}>
              {index + 1}. {item.ref_number || '-'}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

const UnfinishedTransactions = ({ data, loading }) => {
  const { formatMessage } = useIntl()

  // null = data tidak tersedia (shift belum ditutup / shift lama), jangan dianggap 0
  const notAvailable = formatMessage({ id: 'report.not_available' })

  const { invoices, orders } = useMemo(() => {
    const details = Array.isArray(data?.unpaid_details) ? data.unpaid_details : []
    return {
      invoices: details.filter((item) => item?.trans_type_id === transType.INVOICE),
      orders: details.filter((item) => item?.trans_type_id === transType.ORDER),
    }
  }, [data?.unpaid_details])

  const isDetailsAvailable = Array.isArray(data?.unpaid_details)

  return (
    <Card
      className={styles.card}
      loading={loading}
      title={
        <SectionHeader
          icon={<HourglassOutlined />}
          iconClassName={styles.iconAmber}
          title={formatMessage({ id: 'report.unfinished_transactions' })}
        />
      }
    >
      <ItemsRow>
        <ItemRow
          title={formatMessage({ id: 'report.unpaid_invoice_count' })}
          amount={
            data?.unpaid_transaction == null ? notAvailable : qtyToCurrency(data.unpaid_transaction)
          }
        />
        <ItemRow
          title={formatMessage({ id: 'report.unpaid_invoice_amount' })}
          amount={data?.unpaid_amount == null ? notAvailable : currency(data.unpaid_amount)}
        />
        {isDetailsAvailable ? (
          <>
            <DetailGroup title={formatMessage({ id: 'report.unpaid_invoices' })} items={invoices} />
            <DetailGroup title={formatMessage({ id: 'report.open_orders' })} items={orders} />
          </>
        ) : null}
      </ItemsRow>
    </Card>
  )
}

export default UnfinishedTransactions
